{
  "app.name": "studio",
  "app.tagline": "NovaTechnica platform — super-admin console + agency owner UI",
  "nav.home": "Accueil",
  "nav.login": "Se connecter",
  "nav.logout": "Se déconnecter",
  "nav.account": "Mon compte",
  "lang.switcher.label": "Langue",
  "lang.fr": "Français",
  "lang.en": "English",
  "loading": "Chargement…",
  "error.generic": "Une erreur est survenue.",
  "error.network": "Impossible de joindre le serveur.",
  "error.unauthorized": "Vous n'êtes pas authentifié."
}
